// DEPRECATED?

export default [
  {
    path: "/gfrecommendations/:userId",
    name: "gfrecommendations",
    component: () => import(/* webpackChunkName: "gf" */ "@/views/gf/gfRecommendations.vue"),
  },
  {
    path: "/kursliste/:studiocode",
    name: "courseListWeekly",
    component: () => import(/* webpackChunkName: "gf" */ "@/views/gf/courseListWeekly.vue"),
  },
  {
    path: "/kursliste/:studiocode/clean",
    name: "courseListWeeklyClean",
    component: () => import(/* webpackChunkName: "gf" */ "@/views/gf/courseListWeekly.vue"),
  },
  {
    path: "/kurslisten",
    name: "courseEdit",
    meta: {
      hideLogo: true,
      navbarTitle: "Group Fitness",
      hideAppBar: false,
      hideBottomNavigation: false,
      navbarTitle: "Kursplan verwaltung",
      fullWidth: true,
    },
    component: () => import(/* webpackChunkName: "gf" */ "@/views/gf/courseEdit_new.vue"),
    children: [
      {
        meta: { hideBottomNavigation: true },
        path: "add",
        name: "courseCreateTimeline",
        component: () => import("@/views/gf/courseCreateTimeline_new.vue"),
      },
      {
        meta: { hideBottomNavigation: true },
        path: "edit/:id",
        name: "courseEditTimeline",
        component: () => import("@/views/gf/courseEditTimeline_new.vue"),
      },
    ],
  },
  {
    path: "/kurse",

    name: "courseList",
    meta: { navbarTitle: "Group Fitness", hideAppBar: false, hideBottomNavigation: false, fullWidth: true, removeTopMarginNavbarTitle: true },
    //meta: { navbarTitle: "Group Fitness" },

    component: () => import("@/views/gf/courseList_new.vue"),

    children: [
      {
        path: ":id",

        name: "courseListView",
        component: () => import("@/views/gf/courseListView_new.vue"),
      },
      {
        path: ":id/edit",
        meta: { hideBottomNavigation: true },
        name: "courseListEdit",
        component: () => import("@/views/gf/courseListEdit_new.vue"),
      },
    ],
  },
  {
    path: "/kursliste/:id",
    name: "Kurse_extern",
    component: () => import(/* webpackChunkName: "gf" */ "@/views/gf/Kurse_extern.vue"),
  },
  // VIDEOARCHIV
  {
    path: "/videos",
    meta: { navbarTitle: "Videoarchiv" },
    name: "Videoarchiv",
    component: () => import(/* webpackChunkName: "gf" */ "@/views/gf/Videoarchiv.vue"),
  },
]
